export default __webpack_public_path__ + "dbd2c3a24168b9f6981317dc6ce4d9de.svg";